import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import HomePage from "@/pages/HomePage";
import AboutPage from "@/pages/AboutPage";
import OpportunitiesPage from "@/pages/OpportunitiesPage";
import PriceListPage from "@/pages/PriceListPage";
import PrivacyPolicyPage from "@/pages/PrivacyPolicyPage";
import ConfirmAppointmentPage from "@/pages/ConfirmAppointmentPage";
import StylistCalendarPage from "@/pages/StylistCalendarPage";
import AllCalendarsPage from "@/pages/AllCalendarsPage";
import LoginPage from "@/pages/LoginPage";
import TakingsPage from "@/pages/TakingsPage";
import ProtectedRoute from "@/components/ProtectedRoute";
import { AuthProvider } from "@/context/AuthContext";
import CookieBanner from "@/components/CookieBanner";

// Scroll to top on route change
function ScrollToTop() {
  const { pathname } = useLocation();
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  
  return null;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/opportunities" element={<OpportunitiesPage />} />
            <Route path="/prices" element={<PriceListPage />} />
            <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
            <Route path="/confirm/:token" element={<ConfirmAppointmentPage />} />

            {/* Back office (auth protected) */}
            <Route path="/backoffice/login" element={<LoginPage />} />
            <Route path="/backoffice" element={<ProtectedRoute><AllCalendarsPage /></ProtectedRoute>} />
            <Route path="/calendar" element={<ProtectedRoute><AllCalendarsPage /></ProtectedRoute>} />
            <Route path="/calendar/:stylistName" element={<ProtectedRoute><StylistCalendarPage /></ProtectedRoute>} />
            <Route path="/takings" element={<ProtectedRoute><TakingsPage /></ProtectedRoute>} />

            {/* Legacy URL Redirects */}
            <Route path="/about-our-hairdressers-in-southport" element={<Navigate to="/about" replace />} />
            <Route path="/about-our-hairdressers-in-southport/" element={<Navigate to="/about" replace />} />
            <Route path="/booking" element={<Navigate to="/" replace />} />
            <Route path="/booking/" element={<Navigate to="/" replace />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
      <CookieBanner />
      <Toaster position="top-center" />
    </div>
  );
}

export default App;
